const getCompassRotation = bearing => Math.abs(bearing - 360);

export default getCompassRotation;
